(function () {
  var IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutos
  var CHECK_INTERVAL_MS = 15 * 1000; // revisa cada 15 segundos
  var STORAGE_KEY = 'shrine_cart_last_activity';
  var COUNT_KEY = 'shrine_cart_last_count';

  function isCheckoutPage() {
    return window.location.pathname.indexOf('/checkout') !== -1;
  }

  function getCartClearUrl() {
    return (window.routes && window.routes.cart_clear_url) || '/cart/clear.js';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function clearAbandonedCart() {
    fetch(getCartClearUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(COUNT_KEY);
        window.location.reload();
      })
      .catch(function (err) {
        console.error('No se pudo vaciar el carrito abandonado:', err);
      });
  }

  function checkCart() {
    if (isCheckoutPage()) return;

    fetchCart().then(function (cart) {
      var now = Date.now();
      var lastCount = parseInt(localStorage.getItem(COUNT_KEY) || '0', 10);

      if (cart.item_count === 0) {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.setItem(COUNT_KEY, '0');
        return;
      }

      // Si el carrito cambio (se agrego/quito/actualizo algo), reiniciamos el timer
      if (cart.item_count !== lastCount) {
        localStorage.setItem(STORAGE_KEY, String(now));
        localStorage.setItem(COUNT_KEY, String(cart.item_count));
        return;
      }

      var lastActivity = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (!lastActivity) {
        localStorage.setItem(STORAGE_KEY, String(now));
        return;
      }

      if (now - lastActivity >= IDLE_TIMEOUT_MS) {
        clearAbandonedCart();
      }
    }).catch(function (err) {
      console.error('Error revisando el carrito abandonado:', err);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    checkCart();
    setInterval(checkCart, CHECK_INTERVAL_MS);
  });
})();
